import { useEffect, useState } from "react";
import api, { formatErr } from "../../lib/api";
import { toast } from "sonner";
import { Plus, Trash2, Tag } from "lucide-react";

export default function AdminCoupons() {
  const [items, setItems] = useState([]);
  const [code, setCode] = useState("");
  const [percent, setPercent] = useState(20);

  const load = () => api.get("/admin/coupons").then((r) => setItems(r.data));
  useEffect(() => { load(); }, []);

  const create = async (e) => {
    e.preventDefault();
    try {
      await api.post("/admin/coupons", { code, percent_off: parseInt(percent), active: true });
      toast.success("Coupon created");
      setCode(""); setPercent(20);
      load();
    } catch (e) {
      toast.error(formatErr(e.response?.data?.detail) || "Failed");
    }
  };

  const del = async (id) => {
    await api.delete(`/admin/coupons/${id}`);
    load();
  };

  return (
    <div data-testid="admin-coupons-page">
      <h1 className="font-display text-3xl tracking-tight">Coupons</h1>
      <p className="text-muted-foreground text-sm">Run flash sales, student discounts, and promo codes.</p>

      <form onSubmit={create} className="mt-6 flex gap-3 flex-wrap items-end">
        <div>
          <div className="text-[11px] uppercase font-bold tracking-wider text-muted-foreground mb-1">Code</div>
          <input value={code} onChange={(e) => setCode(e.target.value.toUpperCase())} placeholder="LAUNCH50" className="h-10 rounded-md border border-border bg-background px-3 text-sm" required />
        </div>
        <div>
          <div className="text-[11px] uppercase font-bold tracking-wider text-muted-foreground mb-1">% off</div>
          <input type="number" min={1} max={100} value={percent} onChange={(e) => setPercent(e.target.value)} className="h-10 w-24 rounded-md border border-border bg-background px-3 text-sm" />
        </div>
        <button type="submit" className="btn-primary"><Plus className="h-4 w-4" /> Create</button>
      </form>

      <div className="mt-8 grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {items.map((c) => (
          <div key={c.id} className="rounded-xl border border-border bg-card p-5 flex items-center gap-3">
            <Tag className="h-5 w-5 text-[color:var(--brand-blue)]" />
            <div className="flex-1">
              <div className="font-mono font-bold">{c.code}</div>
              <div className="text-xs text-muted-foreground">{c.percent_off}% off · {c.active ? "Active" : "Disabled"}</div>
            </div>
            <button onClick={() => del(c.id)} className="text-rose-500 hover:bg-rose-500/10 rounded p-1.5"><Trash2 className="h-4 w-4" /></button>
          </div>
        ))}
      </div>
    </div>
  );
}
